<template>
  <div class="inscription-change-status">
    <!-- Status disabled -->
    <app-status
      class="inscription-change-status__disabled"
      v-if="isDisabledStatus"
      :text="getStatusLabel(statusSelected)"
      :color="getTagStyle('status', statusSelected).color"
    />

    <!-- Select Select -->
    <el-select
      v-model="statusSelected"
      v-else
      :disabled="isDisabledStatus"
      class="inscription-change-status__select"
      @change="onChangeSelect(statusSelected)"
    >
      <i
        slot="prefix"
        class="inscription-change-status__select__prefix icon-radio-button-fill"
        :style="getTagStyle('status', statusSelected)"
      />

      <span class="inscription-change-status__select__content">
        <el-option
          v-for="status in statusSupportedList"
          :key="status.id"
          :label="status.label"
          :value="status.id"
          class="inscription-change-status__select__content__option"
        >
          <span style="float: left">
            <i class="icon-radio-button-fill" :style="getTagStyle('status', status.id)" />
          </span>
          <div
            style="float: center; color: #606266; font-size: 12px"
          >
            {{ status.label }}
          </div>
        </el-option>
      </span>
    </el-select>

    <el-dialog
      :before-close="back"
      :visible.sync="dialogVisible"
      width="90%"
      class="inscription-change-status__modal el-dialog--center"
    >
      <!-- Header -->
      <span slot="title" class="inscription-change-status__modal__header">
        <app-i18n
          class="inscription-change-status__modal__header__title"
          code="entities.inscription.modal.title"
        />
        <div class="inscription-change-status__modal__header__status">
          <span
            class="inscription-change-status__modal__header__old__status"
          >{{i18n(`enumerators.inscriptionStatus.${statusInitial}`)}}</span>
          <span
            class="inscription-change-status__modal__header__new__status"
          >> {{i18n(`enumerators.inscriptionStatus.${statusSelected}`)}}</span>
        </div>
      </span>

      <!-- Card -->
      <app-view-card
        class="inscription-change-status__modal__player-card"
        v-if="playerCardParams"
        :title="playerCardParams.title"
        :fieldsValuesArray="playerCardParams.fieldsValuesArray"
        :icon="playerCardParams.icon"
      />

      <!-- Team transfer -->
      <app-team-list-transfer
        class="inscription-change-status__modal__transfer-teams"
        :key="teamListTransferKey"
        v-if="subpropertyId"
        :subpropertyId="subpropertyId"
        :listTeamPlayerInitial="[]"
        :listTeamPlayerResult.sync="listTeamPlayer"
        :playerFullname="playerFullname"
        :programInitial="program"
        :subprogramInitial="subprogram"
      ></app-team-list-transfer>

      <!-- Footer -->
      <span slot="footer" class="inscription-change-status__modal__footer">
        <el-button
          :disabled="disableSubmitDialog"
          type="primary"
          @click="doSubmit()"
        >{{i18n('common.update')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import TeamListTransfer from '@modules/team/components/team-list-transfer.vue';
import { mapGetters, mapActions } from 'vuex';
import { InscriptionModel } from '@modules/inscription/inscription-model';
import { ProgramModel } from '@modules/program/program-model';
import TagsFactory from '@shared/factories/tags-factory';

export default {
  name: 'inscription-change-status',
  props: {
    inscriptionData: {
      type: Object,
      required: true,
    },

    subpropertyId: {
      type: String,
      required: true,
    },

    onFinishSubmitFn: {
      type: Function,
      required: true,
    },

    doNavigation: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      dialogVisible: false,
      hasPayments: false,
      statusInitial: null,
      statusSelected: null,
      teamListTransferKey: 0,
      inscriptionSelectKey: 0,
      listTeamPlayer: [],
    };
  },

  created() {
    const { status, subprogram } = this.inscriptionData;
    this.hasPayments =
      subprogram.payment != undefined
        ? subprogram.payment.exist
        : false;
    this.statusInitial = status;
    this.statusSelected = status;
  },

  computed: {
    ...mapGetters({
      filter: 'inscription/list/filter',
      currentUser: 'auth/currentUser',
    }),

    isAdmin() {
      const { isAdmin } = this.currentUser
        ? this.currentUser
        : {};
      if (isAdmin) {
        return true;
      }
      return false;
    },

    isDisableStatusAction() {
      return (
        process.env
          .VUE_APP_DISABLE_INSCRIPTION_STATUSCHANGE ===
        'true'
      );
    },

    isDisabledStatus() {
      const isAccepted =
        this.statusSelected === 'approved' ||
        (this.statusSelected === 'onTryout' &&
          !this.hasPayments) ||
        this.statusSelected === 'paid' ||
        this.statusSelected === 'reject';
      return this.isDisableStatusAction || isAccepted;
    },
    allStatusSupportList() {
      let statusSuported = [
        'pendingApproval',
        'onTryout',
        'approved',
        'pendingPayment',
        'paid',
        'reject',
      ];

      return this.fields.status.options.filter(({ id }) => {
        return statusSuported.some(
          (status) => status === id,
        );
      });
    },
    statusSupportedList() {
      let statusSuported = [];

      if (this.isDisabledStatus) {
        statusSuported = [
          'pendingApproval',
          'onTryout',
          'approved',
          'pendingPayment',
          'paid',
          'reject',
        ];

        return this.fields.status.options.filter(
          ({ id }) => {
            return statusSuported.some(
              (status) => status === id,
            );
          },
        );
      }

      if (this.hasPayments) {
        if (this.statusSelected === 'onTryout') {
          statusSuported = [
            'onTryout',
            'pendingPayment',
            'paid',
            'reject',
          ];
        } else if (
          this.statusSelected === 'pendingPayment'
        ) {
          statusSuported = [
            'pendingPayment',
            'paid',
            'reject',
          ];
        } else {
          statusSuported = [
            'pendingApproval',
            'onTryout',
            'pendingPayment',
            'paid',
            'reject',
          ];
        }
      } else {
        statusSuported = [
          'pendingApproval',
          'onTryout',
          'approved',
          'reject',
        ];
      }

      return this.fields.status.options.filter(({ id }) => {
        return statusSuported.some(
          (status) => status === id,
        );
      });
    },

    fields() {
      const { propertyName } = this;
      return InscriptionModel.fields({ propertyName });
    },

    program() {
      return this.inscriptionData.program;
    },

    subprogram() {
      return this.inscriptionData.subprogram;
    },

    playerFullname() {
      const { firstName, lastName } = this.inscriptionData;
      return `${firstName} ${lastName}`;
    },

    disableSubmitDialog() {
      return this.listTeamPlayer.length == 0;
    },

    playerCardParams() {
      const { firstName, lastName } = this.inscriptionData;
      const title = `${firstName} ${lastName}`;
      const programName =
        this.presenterProgram(
          this.inscriptionData.program,
          'type',
        ).toUpperCase() +
        ' ' +
        this.presenter(
          this.inscriptionData.program,
          'name',
        );

      return {
        icon: 'icon-player',
        title,
        fieldsValuesArray: [
          {
            fieldI18n:
              'entities.inscription.fields.birthdate',
            value: this.presenter(
              this.inscriptionData,
              'birthdate',
            ),
            col: { lg: 8, md: 8, sm: 8 },
          },
          {
            fieldI18n: 'entities.inscription.fields.gender',
            value: this.presenter(
              this.inscriptionData,
              'gender',
            ),
            col: { lg: 8, md: 8, sm: 8 },
          },
          {
            fieldI18n: 'entities.program.label.one',
            value: programName,
            col: { lg: 8, md: 8, sm: 8 },
          },
        ],
      };
    },
  },

  methods: {
    ...mapActions({
      doChangeStatus: 'inscription/form/doChangeStatus',
    }),

    getTagStyle(keyEnum, valueEnum) {
      const style = new TagsFactory({
        entityName: 'inscription',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
      return style;
    },

    getStatusLabel(status) {
      return i18n(
        `enumerators.inscriptionStatus.${status}`,
      );
    },

    presenter(row, fieldName) {
      const { propertyName } = this;
      return InscriptionModel.presenter(
        row,
        fieldName,
        propertyName,
      );
    },

    presenterProgram(record, fieldName) {
      return ProgramModel.presenter(record, fieldName);
    },

    async doSubmit() {
      this.dialogVisible = false;
      const { id } = this.inscriptionData;

      this.doChangeStatus({
        id,
        status: this.statusSelected,
        teams: this.listTeamPlayer.map((e) =>  ({ 
          label: e.label,
          id: e.id, 
          program: e.program.id, 
          subprogram: e.subprogram.id, 
        })),
        doNavigation: this.doNavigation
      }).then(() => {
        this.onFinishSubmitFn();
      });
    },

    onChangeSelect(status) {
      const isReject = status === 'reject';
      const isApproved = status === 'approved';
      const isOnTryout = status === 'onTryout';
      const isPendingPayment = status === 'pendingPayment';
      const isPaid = status === 'paid';

      // Reject
      if (isReject) {
        // Update status
        this.doRejectWithConfirm();
        // Others
      } else {
        if (this.statusInitial === 'pendingApproval') {
          if (
            isApproved ||
            isOnTryout ||
            isPendingPayment ||
            isPaid
          ) {
            this.dialogVisible = true;
          }
        } else {
          const { id } = this.inscriptionData;

          this.doChangeStatus({
            id,
            status: this.statusSelected,
            teams: this.listTeamPlayer.map((e) =>  ({ 
              label: e.label,
              id: e.id, 
              program: e.program.id, 
              subprogram: e.subprogram.id, 
            })),
            doNavigation: this.doNavigation
          }).then(() => {
            this.onFinishSubmitFn();
          });
        }
      }
    },

    back() {
      // Hide dialog
      this.dialogVisible = false;

      // Reset status selected
      this.statusSelected = this.statusInitial;

      // Reset team list player
      this.listTeamPlayer = [];
      this.teamListTransferKey++;
    },

    i18n(code) {
      return i18n(code);
    },

    async doRejectWithConfirm() {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );
        const { id } = this.inscriptionData;
        return this.doChangeStatus({
          id,
          status: this.statusSelected,
          teams: this.listTeamPlayer.map((e) =>  ({ 
            label: e.label,
            id: e.id, 
            program: e.program.id, 
            subprogram: e.subprogram.id, 
          })),
        }).then(() => {
          this.onFinishSubmitFn();
        });
      } catch (error) {
        // no
      }
    },
  },

  components: {
    [TeamListTransfer.name]: TeamListTransfer,
  },
};
</script>

<style lang="scss" scoped>
.inscription-change-status {
  display: initial;
  &__select {
    &__content {
      &__option {
        padding: 0 8px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  &__modal {
    &__header {
      &__title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        padding-bottom: 32px;
      }

      &__status {
        font-size: 20px;
        text-transform: uppercase;
      }
      &__old__status {
        color: rgba(64, 64, 64, 0.41);
        font-weight: 500;
      }
      &__new__status {
        font-weight: bold;
        color: #2acccc;
      }
    }

    &__player-card {
      margin: 0 10% 0 10%;
    }

    &__player-card strong {
      color: #404040;
      font-weight: normal;
    }
    &__transfer-teams {
      margin: 0 10% 0 10%;
    }
  }
}
</style>

<style>
.inscription-change-status .el-input__inner {
  display: grid;
  border: initial;
  border-radius: 7.5px;
  box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
  height: 32px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color : #606266;
  font-size: 12px;
}
.inscription-change-status  .el-input__prefix i {
    width: 30px;
    height: 30px;
}
.inscription-change-status  .el-input__icon  {
    height: 34px;
    width: 16px;
    line-height: 32px;
}
.inscription-change-status   .el-input--suffix .el-input__inner {
  padding-right: 32px;
}
.inscription-change-status   .el-input--prefix .el-input__inner {
  padding-left: 32px;
}
</style>